import React from 'react';
import ReacDOM from 'react-dom';
import App from './components/App';

ReacDOM.render(<App />, document.querySelector('#root'));
